import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
//import { MatDialog } from '@angular/material/dialog/dialog';
import { LoginComponent } from 'src/app/modules/home/components/login/login.component';

@Component({
  selector: 'app-login-req',
  templateUrl: './login-req.component.html',
  styleUrls: ['./login-req.component.scss']
})
export class LoginReqComponent implements OnInit {

  constructor(private _matDialog: MatDialog,private _dialogRef: MatDialogRef<LoginReqComponent>) { }

  ngOnInit(): void {
  }

  dialogClose(){
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }

  logIn(): void {

    this._dialogRef.close();

    this._matDialog.open(LoginComponent, {
      width: '100%',
      height: '100%',
      minWidth: '100%',
      minHeight: '100%',
      disableClose: true,
      panelClass: ['custom-modal', 'login-modal', 'animate__animated', 'animate__slideInDown'],
    });
  }
}
